module.exports = __webpack_public_path__ + "static/media/IllusRewards.801060cc.png";